
import { defineComponent, ref } from "vue"


export default defineComponent({
    name: "Loading",
    setup(props, { emit }) {

        const isShow = ref(true)
        const onCancel = () => {
            isShow.value = true
            emit('result', undefined)
        }

        return {
            isShow,
            onCancel,
        };
    },
})
